import { ApiResponseModel } from '../types/ApiResponseModel';
import { DataRequestConfig } from '../types/DataRequestConfig';
import { getApiBaseUrl } from './app.service';
import { executeApiRequest, getAuthToken } from './base.service';
import { getHttpClient, HttpClient } from './httpClient';
import { AnnouncementDataModel } from 'src/types/propTypes/AnnouncementDataModel';

export const announcementsApiPaths = {
  create: 'announcements',
  getAllItems: 'announcements',
  getById: (announcementId: string): string =>
    `announcements/${announcementId}`,
};

export const AnnouncementsServiceClient = (
  config?: DataRequestConfig
): HttpClient =>
  getHttpClient(getApiBaseUrl(), getAuthToken() || '', config?.signal);

export const getAllAnnouncements = async (
  config?: DataRequestConfig
): Promise<ApiResponseModel<AnnouncementDataModel[]>> => {
  return executeApiRequest<AnnouncementDataModel[]>(async () => {
    return await AnnouncementsServiceClient(config).get(
      announcementsApiPaths.getAllItems
    );
  });
};

export const getAnnouncementById = async (
  announcementId: string,
  config?: DataRequestConfig
): Promise<ApiResponseModel<AnnouncementDataModel>> => {
  return executeApiRequest<AnnouncementDataModel>(async () => {
    return await AnnouncementsServiceClient(config).get(
      announcementsApiPaths.getById(announcementId)
    );
  });
};

export const getAnnouncementsByDocumentType = async (
  documentType: string,
  config?: DataRequestConfig
): Promise<ApiResponseModel<AnnouncementDataModel[]>> => {
  return executeApiRequest<AnnouncementDataModel[]>(async () => {
    return await AnnouncementsServiceClient(config).get(
      `announcements/documentType/${documentType}`
    );
  });
};
